import API from "../../utils/api";
import {
    CLEAR_VERDICTS_FILTERS,
    FETCHED_VERDICTS_FILTERS,
    SET_VERDICTS_FILTER,
    SET_VERDICTS_FILTERS,
    SET_VERDICTS_FILTERS_LOADING,
    SET_VERDICTS_FILTERS_FROM_LATEST_SEARCH
} from "../constants";
import {Action} from "./app";
import {localStorageAccessTokenKey} from "../../utils/constants";

export const setVerdictsFilter = (value: any): Action => ({
    type: SET_VERDICTS_FILTER,
    payload: value
});

export const setVerdictsFilters = (value: any): Action => ({
    type: SET_VERDICTS_FILTERS,
    payload: value
});

export const setVerdictsFiltersFromLatestSearch = (value: any): Action => ({
    type: SET_VERDICTS_FILTERS_FROM_LATEST_SEARCH,
    payload: value
});

export const clearVerdictsFilters = (): Action => ({
    type: CLEAR_VERDICTS_FILTERS,
    payload: null
});

export const setVerdictsFiltersLoading = (value: boolean): Action => ({
    type: SET_VERDICTS_FILTERS_LOADING,
    payload: value
});

export const getVerdictsFilters = (payload: any) => async(dispatch: any) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);
    try {
        const response = await API.get("filters?type=verdicts", {
            params: payload,
            headers: {"Authorization": "Bearer " + token}
        });
        dispatch({ type: FETCHED_VERDICTS_FILTERS, payload: response.data });
        return response;
    } catch (err) {
        return err;
    }
};
